import { useEffect } from "react";
import { usePathname } from "next/navigation";

// The in-app Gain (`/gain/*`) routes are deprecated — Gain is now served from
// gain.kerneldao.com. Map each old route to its external equivalent. Note the
// route name differs from the vault slug for airdrop (`airdrop-gain` →
// `airdrop-vault`).
const GAIN_ROUTE_REDIRECTS: Record<string, string> = {
  "/gain": "https://gain.kerneldao.com",
  "/gain/growth-vault": "https://gain.kerneldao.com/vaults/growth-vault",
  "/gain/airdrop-gain": "https://gain.kerneldao.com/vaults/airdrop-vault",
  "/gain/stable-vault": "https://gain.kerneldao.com/vaults/stable-vault",
};

export const isGainRoute = (pathname?: string | null): boolean => {
  if (!pathname) return false;
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return normalized === "/gain" || normalized.startsWith("/gain/");
};

/**
 * Client-side fallback that redirects any deprecated `/gain/*` route to the
 * external Gain app. Static export can't do server redirects, so this runs on
 * mount. Unmapped `/gain/*` paths fall back to the Gain vaults landing.
 */
const useGainRouteRedirect = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (!isGainRoute(pathname)) return;
    const normalized = (pathname as string).replace(/\/+$/, "") || "/";
    const target =
      GAIN_ROUTE_REDIRECTS[normalized] || "https://gain.kerneldao.com/vaults";
    window.location.replace(target);
  }, [pathname]);
};

export default useGainRouteRedirect;
